export enum TrackingEventType {
  // Email Verification Step
  ONBOARDING_EMAIL_VERIFICATION_VIEWED = 'onboarding_emailVerification_viewed',
  ONBOARDING_EMAIL_VERIFICATION_RESENT = 'onboarding_emailVerification_resent',

  // Onboarding Welcome Step
  ONBOARDING_WELCOME_VIEWED = 'onboarding_welcome_viewed',
  ONBOARDING_WELCOME_CLICKED = 'onboarding_welcome_clicked',

  // Onboarding HZB (= University Entrance Qualification Type) Step
  ONBOARDING_HZB_VIEWED = 'onboarding_hzb_viewed',
  ONBOARDING_HZB_SAVED = 'onboarding_hzb_saved',
  ONBOARDING_HZB_BACK_BUTTON_CLICKED = 'onboarding_hzb_backButtonClicked',

  // Onboarding EEB (= Erfolgreiche Erstberatung / Successful Consultation)
  ONBOARDING_EEB_VIEWED = 'onboarding_eeb_viewed',

  // Consultation Rebooking Step
  EEB_REBOOKING_VIEWED = 'eeb_rebooking_viewed',

  // Mainscreen EEB (= Erfolgreiche Erstberatung / Successful Consultation)
  MAIN_SCREEN_EEB_VIEWED = 'mainscreen_eeb_viewed',
  MAIN_SCREEN_EEB_OPTIONAL_CLICKED = 'mainscreen_eeb_optional_clicked',

  // EEB (= Erfolgreiche Erstberatung / Successful Consultation)
  EEB_STARTED = 'eeb_booking_started',

  // Onboarding Language Step
  ONBOARDING_LANGUAGE_VIEWED = 'onboarding_language_viewed',
  ONBOARDING_LANGUAGE_BACK_BUTTON_CLICKED = 'onboarding_language_backButtonClicked',
  ONBOARDING_LANGUAGE_SAVED = 'onboarding_language_saved',

  // Onboarding Insufficient German Language Skills Step
  ONBOARDING_LANGUAGE_BLOCKED_VIEWED = 'onboarding_languageBlocked_viewed',
  ONBOARDING_LANGUAGE_BLOCKED_CLICKED = 'onboarding_languageBlocked_clicked',

  // Onboarding International Success Step
  ONBOARDING_INTERNATIONAL_SUCCESS_VIEWED = 'onboarding_internationalSuccess_viewed',
  ONBOARDING_INTERNATIONAL_SUCCESS_CLICKED = 'onboarding_internationalSuccess_clicked',

  // Hzb Document Upload Step
  ONBOARDING_HZBUPLOAD_VIEWED = 'onboarding_hzbUpload_viewed',
  ONBOARDING_HZBUPLOAD_UPLOADED = 'onboarding_hzbUpload_uploaded',

  // Lanuage Certificate Upload Step
  ONBOARDING_LANGUAGECERT_UPLOAD_VIEWED = 'onboarding_languageUpload_viewed',
  ONBOARDING_LANGUAGECERT_UPLOADED = 'onboarding_languageUpload_uploaded',

  // Main Screen / DS Home
  MAIN_SCREEN_VIEWED = 'mainscreen_viewed',
  MAIN_SCREEN_TASK_CLICKED = 'mainscreen_task_clicked',
  MAIN_SCREEN_CONTACT_CLICKED = 'mainscreen_contact_clicked',
  MAIN_SCREEN_TRAINING_CLICKED = 'mainscreen_training_clicked',
  MAIN_SCREEN_BEWERBUNGSTRAINING_CLICKED = 'mainscreen_bewerbungstraining_clicked',
  MAIN_SCREEN_DOCUMENTS_BUILDER_CARD_CLICKED = 'mainscreen_documents_card_clicked',

  // Matching
  MATCHING_POSITION_APPLIED = 'matching_position_applied',
  MATCHING_POSITION_SAVED = 'matching_position_saved',
  MATCHING_ADDITIONALOPTIONS_CLICKED = 'matching_additionaloptions_clicked',

  // Matching Quiz - Social Work Area Question
  CRITERIA_SOCIAL_WORK_AREA_VIEWED = 'criteria_socialWorkArea_viewed',
  CRITERIA_SOCIAL_WORK_AREA_SAVED = 'criteria_socialWorkArea_saved',
  CRITERIA_SOCIAL_WORK_AREA_BACK_BUTTON_CLICKED = 'criteria_socialWorkArea_backButtonClicked',

  // Matching Quiz - Prior Experience Question
  CRITERIA_PRIOR_EXPERIENCE_VIEWED = 'criteria_priorExperience_viewed',
  CRITERIA_PRIOR_EXPERIENCE_SAVED = 'criteria_priorExperience_saved',
  CRITERIA_PRIOR_EXPERIENCE_BACK_BUTTON_CLICKED = 'criteria_priorExperience_backButtonClicked',

  // Matching Quiz - Start Date / Intake Interests Step
  CRITERIA_START_DATE_VIEWED = 'criteria_startDate_viewed',
  CRITERIA_START_DATE_SAVED = 'criteria_startDate_saved',
  CRITERIA_START_DATE_BACK_BUTTON_CLICKED = 'criteria_startDate_backButtonClicked',

  // Matching Quiz - Foreign Languages Step
  CRITERIA_FOREIGN_LANGUAGES_VIEWED = 'criteria_foreignLanguages_viewed',
  CRITERIA_FOREIGN_LANGUAGES_SAVED = 'criteria_foreignLanguages_saved',
  CRITERIA_FOREIGN_LANGUAGES_BACK_BUTTON_CLICKED = 'criteria_foreignLanguages_backButtonClicked',

  // Matching Quiz - Language Level Sub-Step
  CRITERIA_LANGUAGE_LEVEL_VIEWED = 'criteria_languageLevel_viewed',
  CRITERIA_LANGUAGE_LEVEL_BACK_BUTTON_CLICKED = 'criteria_languageLevel_backButtonClicked',

  // Matching Quiz - Campus Step
  CRITERIA_MOVE_VIEWED = 'criteria_move_viewed',
  CRITERIA_MOVE_SAVED = 'criteria_move_saved',
  CRITERIA_CAMPUS_VIEWED = 'criteria_campus_viewed',
  CRITERIA_CAMPUS_SAVED = 'criteria_campus_saved',
  CRITERIA_CAMPUS_BACKBUTTON_CLICKED = 'criteria_campus_backButtonClicked',

  // Matching Quiz - Drivers License Step
  CRITERIA_DRIVERS_LICENSE_VIEWED = 'criteria_driversLicense_viewed',
  CRITERIA_DRIVERS_LICENSE_SAVED = 'criteria_driversLicense_saved',
  CRITERIA_DRIVERS_LICENSE_BACK_BUTTON_CLICKED = 'criteria_driversLicense_backButtonClicked',

  // Matching Quiz - Car Access Step
  CRITERIA_CAR_ACCESS_VIEWED = 'criteria_carAccess_viewed',
  CRITERIA_CAR_ACCESS_SAVED = 'criteria_carAccess_saved',
  CRITERIA_CAR_ACCESS_BACK_BUTTON_CLICKED = 'criteria_carAccess_backButtonClicked',

  // Matching Quiz - Study Courses
  CRITERIA_STUDY_COURSES_VIEWED = 'criteria_studyCourses_viewed',
  CRITERIA_STUDY_COURSES_SAVED = 'criteria_studyCourses_saved',
  CRITERIA_STUDY_COURSES_BACK_BUTTON_CLICKED = 'criteria_studyCourses_backButtonClicked',

  // Matching Quiz - Success Screen
  CRITERIA_SUCCESS_VIEWED = 'criteria_success_viewed',
  CRITERIA_SUCCESS_CLICKED = 'criteria_success_clicked',
  CRITERIA_SUCCESS_BACK_BUTTON_CLICKED = 'criteria_success_backButtonClicked',

  // Matching Quiz - BWL Step
  CRITERIA_BWL_SPECIALIZATION_VIEWED = 'criteria_bwlSpecialisation_viewed',
  CRITERIA_BWL_SPECIALIZATION_SAVED = 'criteria_bwlSpecialisation_saved',
  CRITERIA_BWL_SPECIALIZATION_BACK_BUTTON_CLICKED = 'criteria_bwlSpecialisation_backButtonClicked',

  // Matching Quiz - Distance / Mobility
  CRITERIA_DISTANCE_VIEWED = 'criteria_distance_viewed',
  CRITERIA_DISTANCE_SAVED = 'criteria_distance_saved',
  CRITERIA_DISTANCE_BACK_BUTTON_CLICKED = 'criteria_distance_backButtonClicked',
}
